import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 리뉴얼
  {
    path: "/",
    component: () => import("@/page/Ongjinenglish/index"),
    meta: {
      title: "Ongjinenglish",
    },
  },
];

const ongjinenglish = new VueRouter({
  mode: "history",
  routes,
});

ongjinenglish.afterEach((to, from) => {
  const title = to.meta.title === undefined ? "CarrotSolutions" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default ongjinenglish;
